import othersLogo from '../assets/logo-mercado-pago-flow-fintoc.png'
import transferLogo from '../assets/logo-transfer.png'
import creditDebitLogo from '../assets/logo-visa-mastercard-background-white.png'

export const TBK_ENVIRONMENT = process.env.REACT_APP_TRANSBANK_ENVIRONMENT || 'DEV'

export const KLAP = 'klap'
export const WEBPAY = 'webpay'
export const GETNET = 'getnet'
export const OTHERS = 'others'

export const PINFLAG_PAYMENT_METHODS = [
  KLAP,
  GETNET,
  WEBPAY
]

export const PINFLAG = 'pinflag'

export const SHOPIFY_PINFLAG_PAYMENT_METHOD = 'Pinflag'

export const DEFAULT_SSN = '66666666-6'

export const PINFLAG_PAYMENT_OPTIONS = [
  {
    type: 'credit',
    title: 'Tarjeta de Crédito',
    subTitle: 'Visa, Mastercard',
    logo: creditDebitLogo,
    logoWidth: '55px'
  },
  {
    type: 'debit',
    title: 'Tarjeta de Débito',
    subTitle: 'Visa, Mastercard',
    logo: creditDebitLogo,
    logoWidth: '55px'
  },
  {
    type: 'transfer',
    title: 'Transferencia Bancaria',
    subTitle: 'Desde tu banco',
    logo: transferLogo,
    logoWidth: '95px'
  },
  {
    type: 'others',
    title: 'Otros',
    subTitle: '',
    logo: othersLogo,
    logoWidth: '65px'
  }
]

export const PINFLAG_PAYMENT_MESSAGE = {
  klap: {
    debit: 'Debit Card (Klap)',
    credit: 'Credit Card (Klap)'
  },
  getnet: {
    debit: 'Debit Card (Getnet)',
    credit: 'Credit Card (Getnet)'
  },
  webpay: {
    debit: 'Debit Card (Webpay)',
    credit: 'Credit Card (Webpay)'
  }
}
